import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import HeroLightStudy from "@/pages/HeroLightStudy";
import Work from "@/pages/Work";
import WorkProject from "@/pages/WorkProject";
import Enquire from "@/pages/Enquire";
import ThankYou from "@/pages/ThankYou";
import Press from "@/pages/Press";
import Careers from "@/pages/Careers";
import CareerRole from "@/pages/CareerRole";
import SiteLayout from "@/components/site/SiteLayout";
import Villa142Questionnaire from "@/pages/Villa142Questionnaire";
import Villa142Responses from "@/pages/Villa142Responses";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          {/* Homepage owns its own animated nav + brand-mark inside the
              hero, and renders its own Footer at the end of the page. */}
          <Route path="/" element={<HeroLightStudy />} />
          <Route path="/hero-light-study" element={<HeroLightStudy />} />

          {/* Project galleries keep their immersive slide chrome
              (Selected Work / PREV / NEXT). No global header/footer
              here to avoid colliding with those controls. */}
          <Route path="/work/:slug" element={<WorkProject />} />

          {/* Private client questionnaire — standalone chrome. */}
          <Route path="/villa142questionnaire" element={<Villa142Questionnaire />} />
          <Route path="/villa142questionnaire/responses" element={<Villa142Responses />} />

          {/* All other informational / archive routes share the
              global site chrome (header + footer). */}
          <Route element={<SiteLayout />}>
            <Route path="/work" element={<Work />} />
            <Route path="/enquire" element={<Enquire />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/press" element={<Press />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/careers/:slug" element={<CareerRole />} />
          </Route>

          <Route path="/old-home" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
